<template>
<!--
  description  书城和技术文档合板
               此页未使用
-->
  <div id="content"
  v-loading='loading'
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('bookList')">工业文库</div>
      </div>
    </header>
    <div class="item-class-show"
         style="background:white">
      <el-row class="item-class-group"
              style="border-bottom:1px solid #eee">
        <el-col class="item-class-name"
                style="text-align:center;padding-top:4px;"
                :span="2">
          <span class="book-size">按专题:</span>
        </el-col>
        <el-col class="item-class-name item-class-group"
                :span="22">
          <div v-for="(data,index) in specialList"
               :key="data.id"
               style="line-height:40px"
               :class="specialTabIndex===index ?'bac':''"
               class="book-item book-size"
               @click="specialBtn(data,index)">
            <span>{{data.fileTypeName}}</span>
          </div>
        </el-col>
      </el-row>
      <div v-show="specialTabIndex === 0">
        <el-row class="item-class-group"
                style="border-bottom:1px solid #eee">
          <el-col class="item-class-name"
                  style="text-align:center"
                  :span="2">
            <span class="book-size">按专业:</span>
          </el-col>
          <el-col class="item-class-name item-class-group"
                  :span="22">
            <div v-for="(data,index) in courseList"
                :key="data.id"
                style="line-height:40px"
                :class="tabIndex===index && !tabSecIndex?'bac':''"
                class="book-item book-size"
                @click="handleSecond(data.id,data.typeName,index)">
              <span>{{data.typeName}}</span>
            </div>
          </el-col>
        </el-row>
        <!-- 二级类目 -->
        <el-row class="item-class-group"
                v-if="secondList.length">
          <el-col class="item-class-name"
                  :span="2">
            <span class="book-size"></span>
          </el-col>
          <el-col class="item-class-name item-class-group"
                  :span="22">
            <div v-for="(data,index) in secondList"
                :key="data.id"
                class="book-item book-size"
                @click="handleCourse(data.id,index)"
                :class="tabSecIndex===index?'bac':''">
              <span>{{data.typeName}}</span>
            </div>
          </el-col>
        </el-row>
        <!-- 关注度 -->
        <el-row>
          <el-col :span="24">
            <div class="question-classify">
              <ul>
                <li v-for="(data,index) in datalist2"
                    :class="`${currentIndex===index?'checked':''}`"
                    :key="index"
                    @click="handleIndex(index)">{{data}}<span v-if="index === 2 && a === 3 && currentIndex ===2">↓</span><span v-else-if="index === 2 && a===4 && currentIndex ===2">↑</span></li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 图书列表 -->
    <div v-show="specialTabIndex === 0" class="train-container booklist"
         style="margin-top:15px">
      <div v-for="(item, index) in dataList"
           :key="item.id"
           class="book"
           :class="index%4==0? 'course-margin' :''">
        <div class="course-img">
          <img :src="item.url?item.url:imgUrl"
               :alt="item.bookName"
               width="280px"
               height="194px"
               @click="handleDetail(item.id)" />
        </div>
        <div class="course-name">
          <h3 class="overell">{{item.bookName}}</h3>
        </div>
        <div class="course-info">
          <div>
            <span>{{item.salesVolumes || 0}}人学习</span>
            &nbsp;| &nbsp;
            <span>{{item.viewCount || 0}}浏览</span>
          </div>
          <div>
            <span class="course-info-price">{{item.currentPrice && Number(item.currentPrice) > 0 ? ( '￥' + item.currentPrice) : '免费'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="specialTabIndex === 0" class="doclist-pagination"
         v-if="dataList === [] || dataList.length !== 0">
      <div class="doclist-lastpage"
           @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''"
            v-for="(item, index) in pageList"
            :key="index"
            @click="getBookList(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage"
           @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{totalPage}}页，到第
        <input type="text"
               v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump"
           @click="jumpFarPage">确定</div>
    </div>
    <!-- 技术文档区域 -->
    <div class="k-tecdocument"  v-show="specialTabIndex !== 0" >
      <div class="title-box">
        <!-- <h2>工控文库</h2> -->
      <!-- 技术文档列表跳转 -->
        <router-link class="k-doctypelist-more"
                     to="/trainbookDocList">
          <span>更多</span>
          <!-- <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC"> -->
          <div class="morePicture"></div>
        </router-link>
      </div>
      <!-- 技术文档缩略展示区域 -->
      <div v-if="
          tecDocList &&
          tecDocList.allothers.length === 0 &&
          tecDocList.hot.length === 0 &&
          tecDocList.newVoList.length === 0 &&
          tecDocList.perfect.length === 0
        "
           style="
          width: 1190px;
          height: 630px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #ffffff;
        "
      >
        <img style="display: block" :src="BASE_URL + 'img/kong.png'" alt="暂无数据" />
        <h3 style="margin: 30px; font-size: 28px">
          该分类下暂无文档，请浏览其他分类
        </h3>
      </div>
      <ul class="k-doclist"
          v-if="tecDocList">
        <li v-for="(item, index) in tecDocList.perfect"
            :key="index"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img alt="精品"
               class="k-doctype k-supremedoc"
               src="data:image/png;base64,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" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"/>
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <!-- <div>{{ item.fileViewCount }}人浏览</div> -->
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState(item)
                " />
              <div class="k-docview-collect"
                  :class="{ 'k-docview-collect-active':item.collectionDataId ? true : false}"
                   @click.stop="
                  changeLikeState(item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收 藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.hot"
            :key="index + 3"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img alt="热"
               class="k-doctype k-hotdoc"
               src="data:image/png;base64,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" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <!-- <div>{{ item.fileViewCount }}人浏览</div> -->
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState(item)
                " />
              <div class="k-docview-collect"
                  :class="{ 'k-docview-collect-active':item.collectionDataId ? true : false}"
                   @click.stop="
                  changeLikeState(item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收 藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.newVoList"
            :key="index + 6"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img class="k-doctype k-newdoc"
               src="data:image/png;base64,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" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <!-- <div>{{ item.fileViewCount }}人浏览</div> -->
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState(item)
                " />
              <div class="k-docview-collect"
                  :class="{ 'k-docview-collect-active':item.collectionDataId ? true : false}"
                   @click.stop="
                  changeLikeState(item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收 藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.allothers"
            :key="index + 9"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL || defaultImg"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <!-- <div>{{ item.fileViewCount }}人浏览</div> -->
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState(item)
                " />
              <div class="k-docview-collect"
                  :class="{ 'k-docview-collect-active':item.collectionDataId ? true : false}"
                   @click.stop="
                  changeLikeState(item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收 藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import bookdetail from './bookdetail'
// 引入埋单方法
import { track } from '@/utils/knowledgeEventTracking'
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      totalPage: 0,
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      courseList: [],
      secondList: [],
      datalist2: ['关注度', '最新', '价格'],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 12,
      totalData: 0,
      dataForm: {
        tag: 1, // 关注度
        type: null // 图书的类型id 一级或二级类目id
      },
      dataList: [],
      imgUrl: require('@/assets/img/占位图_en.png'),
      tabIndex: 0,
      tabSecIndex: '',
      count: 0,
      a: 3,
      specialList: [ // 专题列表
        {
          id: null,
          fileTypeName: '培训教材'
        }
      ],
      specialTabIndex: 0, // 专题选中Index
      tecDocList: null, // 技术文档详情展示存储
      defaultImg: require('@/assets/img/defaultPeopleImg.png'),
      // 收藏后红心icon的base64码
      likeUrl:
        'data:image/png;base64,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',
      // 未收藏时蓝心icon的base64码
      notLikeUrl:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTA1Mzk1MTc5RDQ3MTFFOUIyQTZEMUI0QzVFOTI5MkYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTA1Mzk1MTg5RDQ3MTFFOUIyQTZEMUI0QzVFOTI5MkYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMDUzOTUxNTlENDcxMUU5QjJBNkQxQjRDNUU5MjkyRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMDUzOTUxNjlENDcxMUU5QjJBNkQxQjRDNUU5MjkyRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiCR1XQAAAQYSURBVHjatFYNTNRlGP+9fw44jiP5VMBAwesDxS5XulLQy8rKWXNhuTULtrIUxJlbW0Wtub6XrhXT9CRaNZo4m7ml5scYEnRq5LVCMwTxgzoDjC+P77u353np2CEHR8k9t7v/3f+e5/d7n//7vL/nEVJKeFutowNfVdTLY6ev4M/WLhhCdEidEoFH5yYh657pIiIseJh/U3sPSqvOy+/sf+BS8zW43BJJseF40JyIVYtMIj4ybJi/8BDy5f29v0jrkd8x4HIjSNMweZJeATS1dyuf+CgDtuTMQ2baFMG/99guyDd2nUJnd7/6PzHaQLESzR09YFxDqA4FWWY8bTGJEYT5RcflvpMXoQ8OwsuPm5F173QxyTCYTePVLrn90G8oqTgPQaHWtQtwkbLZVGpHGIG+sOQ2ZFtuETERoUNZl9BTKjxwRi1+42Pp2LBslhgi3Hm0Vr65245pcUYFlnZzpIAP+7GuRT63rRJdvQPoG3CTfzg+X78IKZONPv2r61tkrtWGv9q68dm6TCyenSDQ5uxFWv7XMmn1LnnyXLPkBYz1rr/SIc0b90rL6wfk35298Od/7LRDYS98bb90ud3QlVY2yGs9/Vhy51TMNcX6XKm3UQGJT3MzZRztb5QxxJ87Fs6MF5b0BFle40DZrw6pldEXticXpGK8dteMGJEcGy7G60/Vqq5MqtXRMWCbQStHgMwUP4h9jri0NmefOgLJVACBMi7GYJ2GVuLSov/dB00ELEF1lAS9oo2h0JKJnavncoszYISM3TfgAu07tPvSE9TNg/ZGGSjCb6svK+z770iExorC6vJleR16+10TTsaYXxB2AskiHQ+hsbg++8CtJF9OfLT/zIRn+TFhOqgJvLR8NkKpcDS+mffITNJBPXYcPqu6xURZzaVW+cmhs5iVFKU6jSpO/jDqdXh31d3oJ31cs71KOkkrb9Q6qIOwjgZpApupw3gOgeZxeHjOVPGMxQQWgnU7bZLb0v81blF5Vpu80NSJghVmytCrGXgLLWf41IflSmxfLD4h3W7pV5yvf3MML5gxCkqqRzSDEQHcTJe+dVgFbCg+rhR+vGS84DzrDyp29bZKn7E+A9u7+rDsnSMqcO2OKslA/sh6qPxzCitUDNfBaDGjAnCmy987qgAYqJsKaTRf1uMVH5Qp38H9H32B4vohytu4s2cXfi9P1DbBnBKD4rwMEXeTfpgPjxo55EONGU/MT8Hm7HliLFkek1ApBT2a9UU2efBUoxqSinIzkJ4cpSBpspP5RTaV4ZqHbserWWa/HcAvoWeie3vPz2qiYxlcmZGqHvk3NHRxl9m0cs6wyeyGCT1WWtVApf6TUn62yPAQbH1+/tDYOOGEbPaGq3LLvhoYaSB+hcZJmtz+UyP9R4ABACET/mSNAQZ5AAAAAElFTkSuQmCC',
      loading: false
    }
  },
  components: {
    bookdetail
  },
  mounted () {
    // 获取专题列表
    this.getSpecialTabList()
    this.getCourse()
    this.getBookList()
  },
  methods: {
    // 获取专题tab
    getSpecialTabList () {
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFirstLevelFileType`
        )
        .then(({ data }) => {
          this.specialList = this.specialList.concat(data.data)
        })
    },
    // 获取专题列表
    getSpecialList (data) {
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/knowledgeCommunityDisplay/${data.id}`, {
            userId: this.$store.state.user.id || null
          }
        )
        .then(({ data }) => {
          this.nowTimeId = data.id
          this.tecDocList = data.data
          let restList = this.tecDocList.allothers.slice(
            0,
            12 -
            this.tecDocList.newVoList.length -
            this.tecDocList.perfect.length -
            this.tecDocList.hot.length
          )
          this.tecDocList.allothers = restList
        })
    },
    // 实现文档收藏的四个方法（文档对象存在4个list中）
    changeLikeState (item) {
      if (getAccessToken()) {
        let url = ''
        let message = ''

        if (item.collectionDataId === null) {
          url = `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`
          message = '收藏成功'
        } else {
          url = `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`
          message = '已取消收藏'
        }
        this.loading = true
        this.$http
          .post(
            url,
            { collectionType: 'FILE', collectionDataId: item.id }
          )
          .then(({ data }) => {
            this.loading = false
            if (data.code === 0) {
              this.$message.info(message)
              this.getSpecialList(this.specialList[this.specialTabIndex])
            }
          })
          .catch(() => {
            this.loading = false
            // this.$router.push({ name: 'login' })
          })
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    // 文档下载 通过有token校验的其他接口验证是否登陆，登陆才能下载
    download (item) {
      if (this.$store.state.user.id) {
        this.$http
          .get(
            `${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${item.ossId}`
          )
          .then(({ data }) => {
            track.clickDocDownload(item.fileTitle)
            this.downloadFile(item)
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile (item) {
      this.$confirm(`下载${item.fileTitle}需要 ${item.score}积分?`, '提示', {
        confirmButtonText: '确定下载',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return this.$http.post(
            `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/userFileAddMinsPoint/${item.id}`
          )
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.user.id}`
          a.click()
        })
        .catch((err) => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getBookList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getBookList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getBookList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'bookList') {
        this.$router.push({ name: 'bookList' })
      }
    },
    handleIndex (index) {
      this.currentPage = 1
      this.currentIndex = index
      if (index !== 2) {
        this.dataForm.tag = index + 1
      }
      // 判断价格的升序 降序
      if (index === 2) {
        if (this.a === 3) {
          this.dataForm.tag = 4
          this.a = 4
        } else {
          this.dataForm.tag = 3
          this.a = 3
        }
      }
      this.getBookList()
    },
    // 专题切换 (index为0切换tab1 其他切换为tab2 其他之间互相切换时切换数据)
    specialBtn (val, index) {
      this.specialTabIndex = index
      if (index !== 0) {
        this.getSpecialList(val)
      } else {

      }
    },
    // 获取二级类目
    handleSecond (id, name, index) {
      this.currentPage = 1
      this.tabIndex = index
      this.tabSecIndex = ''
      this.courseList.forEach(data => {
        if (id === data.id) {
          this.secondList = data.child ? data.child : []
          this.dataForm.type = id
          this.getBookList()
          if (!data.child) {
            this.dataForm.type = id
            this.getBookList()
          }
        }
      })
      if (name === '全部') {
        this.dataForm.type = null
        this.getBookList()
      }
    },
    handleCourse (id, index) {
      this.currentPage = 1
      this.tabSecIndex = index
      this.tabIndex = ''
      this.dataForm.type = id
      this.getBookList()
    },
    // 获取列表
    getBookList (page = this.currentPage) {
      this.$http.post(`/front/train/trainBook/listAtFrontGround`, {
        'page': page,
        'limit': this.pageSize,
        'tag': this.dataForm.tag,
        'type': this.dataForm.type
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data.data
          // 分页
          this.totalPage = Math.ceil(res.data.count / 12)
          this.changePageTo(page)
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].bookLogoOssId) {
              // this.getUrl(res.data.data[i], res.data.data[i].bookLogoOssId)
            }
          }
        }
      })
    },
    // 获取url
    getUrl (item, id) {
      this.$http.get(`/front/fileupload/alioss/showAliOssSvg/` + id)
        .then(({ data: res }) => {
          if (res.code === 0 && res.svgList[0]) {
            item.url = res.svgList[0]
          }
        })
    },
    // 获取课程分类
    getCourse () {
      this.$http.get(`/help/train/trainBookType/getTree`).then(({ data: res }) => {
        this.courseList = [{ typeName: '全部' }, ...res.data]
      })
    },
    // 跳转详情
    handleDetail (id) {
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`, {
        type: 3, // type --1:新闻/2：课程/3：图书/4：问答
        id: id
      }).then(data => { })
        .catch(() => { })
      this.$router.push({ name: 'bookinfo', query: { id: id } })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getBookList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getBookList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 跳转文档详情页
    jumpDocDetail (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        path: '/trainbookDocDetail',
        query: {
          fileId: item.id
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.container ul,
.container li {
  padding: 0;
  margin: 0;
}
.all-book {
  font-weight: normal;
  margin: 20px 0;
  font-size: 26px;
  border-bottom: 1px solid #ccc;
}
.book-size {
  font-size: 14px;
}
.book-item {
  float: left;
  // margin: 0 15px 4px 0;
  cursor: pointer;
  padding: 0 10px;
}
.question-classify ul {
  width: 100%;
  height: 40px;
}
.question-classify ul li {
  float: left;
  padding: 0 30px;
  color: #333;
  cursor: pointer;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  line-height: 40px;
  height: 40px;
}
.question-classify ul li:first-child {
  border-left: 0;
}
.question-classify ul li.checked {
  background: #1d65a8;
  color: #fff;
}
// 图书列表
.booklist {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.book {
  width: 280px;
  margin-left: 22px;
  margin-bottom: 40px;
  background: #fff;
}
.detail-wrap {
  margin-top: 30px;
}
.book img {
  width: 100%;
  height: 150px;
}
.course-margin {
  margin-left: 0px;
}
.course-img {
  cursor: pointer;
  height: 150px;
}
.course-name {
  margin-top: 10px;
}
.course-name h3 {
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
  padding-left: 5px;
}
.course-info {
  padding-left: 5px;
  line-height: 20px;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.course-info-price {
  /* display: inline-block; */
  padding: 1px 12px;
  text-align: center;
  height: 20px;
  font-size: 22px;
  color: #ff3116;
}
.bac {
  background-color: #1d65a8;
  color: #fff;
}
/* 分页区域样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination {
  display: flex;
  height: 80px;
  padding: 20px 0;
  line-height: 40px;
  text-align: center;
  padding-left: 35px;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
.pageDeavtive {
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 技术文档区域 */
.k-tecdocument h2 {
  font-size: 26px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 10px;
  margin-top: 20px;
}
.k-doctypelisthead {
  display: flex;
  position: relative;
}
.k-doctypelist-more {
  // position: absolute;
  // right: 0;
  padding-left: 8px;
  padding-right: 5px;
  font-size: 14px;
  color: #262626;
  display: flex;
  line-height: 32px;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-more:hover span {
  color: #ffffff;
}
.morePicture {
  width: 10px;
  height: 11px;
  display: block;
  margin-top: 10px;
  margin-left: 6px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-more:hover .morePicture {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTNGRUVFQjFDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTNGRUVFQjJDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBM0ZFRUVBRkM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBM0ZFRUVCMEM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Puq9PDkAAABxSURBVHjalJNJDsAwCAPB//8zbaUeXArBcMgmD4FE9oiwO57BTQi8YqN5BDhzKIBtINBagpD2I4Ti7AihubmFcOivhDC84g+C8FcfSAG4B8dGPJUUVVnYiDugFVfAUZyBUcyAJM6OM8Wm7DjJ05cAAwA/gRgnP8oHOgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover .moreLink {
  color: white !important;
}
.k-doctypelist {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
  height: 32px;
  overflow: hidden;
  margin-bottom: 19px;
}
.k-doctypelist li {
  list-style: none;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 0 10px;
}
.k-doctypelist li:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-active {
  background: #1d65a8;
  color: #ffffff;
}
.k-doclist {
  display: flex;
  flex-wrap: wrap;
  /* border: 1px solid #cccccc; */
}
.k-doclist li {
  list-style: none;
  width: 396px;
  height: 240px;
  box-sizing: border-box;
  position: relative;
  padding: 20px 27px 33px 31px;
  user-select: none;
  cursor: pointer;
}
.k-doclistv-view {
  border: 1px #f9f9f9 solid;
  /* border-bottom: 1px #eeeeee solid;
  border-top: 1px #fff solid;
  border-right: 1px #fff solid; */
  background: #fff;
}
.k-doclistv-view p{
  margin-top: 0;
}
.k-doclistv-view:hover {
  border: 1px solid #1d65a8;
  padding: 20px 27px 33px 31px;
}
.k-doclistv-view:hover .k-doctype {
  /* margin: -2px 0 0 -2px; */
}
.k-doctype {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
}
.k-doclist li h3 {
  font-size: 16px;
  line-height: 45px;
}
.k-doclist li p {
  line-height: 21px;
  font-size: 13px;
  color: #999999;
  margin-bottom: 14px;
  height: 42px;
  overflow: hidden;
}
.k-docauthor {
  display: flex;
  line-height: 30px;
  position: relative;
  margin-bottom: 24px;
}
.k-docauthor-icon {
  width: 29px;
  height: 30px;
  border-radius: 50%;
}
.k-docauthor-name {
  margin-left: 10px;
  font-size: 13px;
  color: #696969;
}
.k-docauthor-date {
  position: absolute;
  right: 8px;
}
.k-docview {
  display: flex;
  position: relative;
}
.k-docview-use {
  display: flex;
  position: absolute;
  right: 8px;
}
.k-docview-likeicon {
  width: 14px;
  height: 13px;
  display: block;
  margin-top: 4px;
}
.k-docview-collect {
  color: #1d65a8;
  margin-right: 32px;
  padding-left: 4px;
}
.k-docview-collect-active{
  color: #f34b18!important;

}
.k-docview-downloadicon {
  width: 15px;
  height: 15px;
  display: block;
  margin-top: 2px;
}
.k-docview-download {
  color: #1d65a8;
  padding-left: 4px;
}
.k-f-upload {
  user-select: none;
  cursor: pointer;
}
.k-f-upload:hover {
  background: #174773;
}
.title-box{
  height:50px;
  display: flex;
  justify-content: space-between;
  flex-direction:row-reverse;
  align-items: center;
}
</style>
